/**
 * 滚动条只在滚动时显形。
 *
 * 样式在 `styles/base.scss`：thumb 默认 `transparent`，`.is-scrolling` 时显形。
 * 这里只负责把那个类打在**正在滚的那个元素**上，停下之后摘掉。
 *
 * 为什么在 capture 阶段监听 document：`scroll` 事件**不冒泡**，挂在 document 上
 * 的普通监听器收不到内层容器的滚动。capture 阶段才能一处收全页所有滚动容器，
 * 不必给每个容器各挂一个。
 */

/** 停止滚动多久之后收起。太短会在惯性滚动的间隙里闪。 */
const HIDE_AFTER_MS = 900

const CLASS = 'is-scrolling'

/** 每个元素各自的收起定时器。用 WeakMap：元素被卸载后条目自动消失。 */
const timers = new WeakMap<Element, number>()

function onScroll(event: Event): void {
  // 文档级滚动的 target 是 `document` 而不是元素，滚动条挂在 `<html>` 上。
  const el = event.target instanceof Element ? event.target : document.documentElement
  el.classList.add(CLASS)

  const pending = timers.get(el)
  if (pending !== undefined) window.clearTimeout(pending)
  timers.set(
    el,
    window.setTimeout(() => {
      el.classList.remove(CLASS)
      timers.delete(el)
    }, HIDE_AFTER_MS),
  )
}

/** 全局注册一次（`main.ts`）。返回注销函数，测试用。 */
export function trackScrollActivity(): () => void {
  document.addEventListener('scroll', onScroll, { capture: true, passive: true })
  return () => document.removeEventListener('scroll', onScroll, { capture: true })
}
